module.exports = __webpack_public_path__ + "static/media/gs.51eef8e4.svg";